import { render, staticRenderFns } from "./CalendarEvents.vue?vue&type=template&id=4ffbc440&scoped=true"
import script from "./CalendarEvents.vue?vue&type=script&lang=js"
export * from "./CalendarEvents.vue?vue&type=script&lang=js"
import style0 from "./CalendarEvents.vue?vue&type=style&index=0&id=4ffbc440&prod&lang=scss&scoped=true"
import style1 from "./CalendarEvents.vue?vue&type=style&index=1&id=4ffbc440&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffbc440",
  null
  
)

export default component.exports